<template>
	<div class="main" id="map">
		<van-search
			v-model="value"
			shape="round"
			background="#FF2222"
			placeholder="请输入搜索关键词"
		/>
		<!-- <div id="map"></div> -->
		<van-tabbar route>
			<van-tabbar-item replace to="/" icon="wap-home-o">
				首页
			</van-tabbar-item>
			<van-tabbar-item replace icon="scan" class="scan"></van-tabbar-item>
			<van-tabbar-item replace to="/user" icon="user-o">
				我的
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import {
	Popup,
	Form,
	Button,
	Field,
	Row,
	Col,
	Tabbar,
	TabbarItem,
	Search,
} from "vant";
import AMap from "AMap";
import wx from "weixin-jsapi";
import { Get } from "@/utils/Api";

export default {
	components: {
		[Popup.name]: Popup,
		[Button.name]: Button,
		[Col.name]: Col,

		[Field.name]: Field,
		[Row.name]: Row,
		[Form.name]: Form,
		[Tabbar.name]: Tabbar,
		[TabbarItem.name]: TabbarItem,
		[Search.name]: Search,
		[AMap.name]: AMap,
	},
	data: function() {
		return {
			value: null,
			map: null,
		};
	},
	created: function() {
		console.log("created");
	},
	mounted: function() {
		console.log("mounted");
		this.init();
		this.getWeChatParams();
		this.getCabinet();
	},
	methods: {
		getCabinet() {
			var T = this;
			Get(
				"queryCabinetService",
				{},
				(r) => {
					console.log("queryCabinetService", r);
					var data = r.data.data;
					for (var i = 0; i < data.length; i++) {
						var cabi = data[i];

						var marker = new AMap.Marker({
							offset: new AMap.Pixel(-16, -16),
							position: new AMap.LngLat(cabi.lng, cabi.lat), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
							icon: "/images/ShuGui.png",
							extData: cabi,
						});

						marker.on("click", T.onMarkClick);

						marker.setLabel({
							offset: new AMap.Pixel(0, 0), //设置文本标注偏移量
							content: cabi.schoolName + "." + cabi.number, //设置文本标注内容
							direction: "right", //设置文本标注方位
						});

						T.map.add(marker);
					}
				},
				(r) => {
					console.log(r);
				}
			);
		},
		onMarkClick(e) {
			var T = this;
			var cab = e.target.w.extData;
			this.$router.push({
				name: "cabinetDetail",
				params: {
					cabnet: cab,
				},
			});

			T.show = true;
		},
		init() {
			var T = this;

			T.map = new AMap.Map("map", {
				center: [116.397428, 39.90923],
				resizeEnable: true,
				zoom: 10,
			});

			wx.ready(function() {
				wx.getLocation({
					type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
					success: function(res) {
						var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
						var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
						T.getWGSLocation(new AMap.LngLat(longitude, latitude));
					},
				});
			});

			// AMap.plugin("AMap.Geolocation", function() {
			// 	var geolocation = new AMap.Geolocation({
			// 		enableHighAccuracy: true, //是否使用高精度定位，默认:true
			// 		timeout: 10000, //超过10秒后停止定位，默认：5s
			// 		buttonPosition: "RB", //定位按钮的停靠位置
			// 		buttonOffset: new AMap.Pixel(10, 60), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
			// 		zoomToAccuracy: true, //定位成功后是否自动调整地图视野到定位点
			// 	});
			// 	T.map.addControl(geolocation);
			// 	geolocation.getCurrentPosition(function(status, result) {
			// 		if (status == "complete") {
			// 			T.onComplete(result);
			// 		} else {
			// 			T.onError(result);
			// 		}
			// 	});
			// });
		},
		// //解析定位结果
		// onComplete(data) {
		// 	this.map.setCenter(data.position);
		// },
		// //解析定位错误信息
		// onError(data) {
		// 	var T = this;
		// 	console.log("onError", data);
		// 	wx.ready(function() {
		// 		wx.getLocation({
		// 			type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
		// 			success: function(res) {
		// 				var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
		// 				var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
		// 				T.getWGSLocation(new AMap.LngLat(longitude, latitude));
		// 			},
		// 		});
		// 	});
		// },
		getWeChatParams() {
			console.log("getWeChatParams");
			Get(
				"getWeChatParams",
				{},
				(r) => {
					console.log("getWeChatParams", r);
					var data = r.data.data;
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp: data.timestamp, // 必填，生成签名的时间戳
						nonceStr: data.nonceStr, // 必填，生成签名的随机串
						signature: data.signature, // 必填，签名
						jsApiList: ["getLocation"], // 必填，需要使用的JS接口列表
					});
				},
				(r) => {
					console.log(r);
				}
			);
		},

		getWGSLocation(locationarg) {
			var T = this;
			console.log("WGS84 location: ", locationarg);
			// 传入经纬度,格式:`${longitude},${latitude}`
			AMap.convertFrom(locationarg, "gps", (status, result) => {
				// WGS84 转高德
				console.log(status, result);
				if (
					status.toLowerCase() === "complete" &&
					result.info.toLowerCase() === "ok"
				) {
					var latlng = result.locations[0];
					T.map.setZoomAndCenter(15, latlng);

					// 将创建的点标记添加到已有的地图实例：
					T.map.add(
						new AMap.Marker({
							position: latlng, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
							icon: "/images/loc.png",
						})
					);
				} else {
					console.log("error");
				}
			});
		},
	},
};
</script>

<style lang="less">
.book-name {
	padding-top: 10px;
	font-weight: bolder;
}
.grid-cabinet {
	padding: 10px;
}
.scan .van-icon-scan {
	z-index: 1000;
	border-radius: 50px;
	background-color: #ff2222;
	font-size: 30px;
	padding: 10px 10px 10px 10px;
	color: #ffffff;
}
.user {
	&-poster {
		width: 100%;
		height: 53vw;
		display: block;
	}

	&-group {
		margin-bottom: 15px;
	}

	&-links {
		padding: 15px 0;
		font-size: 12px;
		text-align: center;
		background-color: #fff;

		.van-icon {
			display: block;
			font-size: 24px;
		}
	}
}

label {
	width: 55px;
	height: 26px;
	line-height: 26px;
	margin-bottom: 0;
}
button.btn {
	width: 80px;
}

#map {
	width: 100%;
	height: 100%;
}

.van-search {
	z-index: 1000;
	position: absolute;
	width: 100%;
}

.van-tabbar {
	z-index: 1000;
}

.amap-logo,
.amap-copyright,
.amap-mcode {
	display: none;
	visibility: hidden;
}
</style>
